<template>

  <div id="changelog">
    <div class="header">
      <div class="logo"></div>
      <div class="version">Version {{ version }}</div>
    </div>
    <div class="dialog-content">
      
      <div class="changelog">

        <div class="section-title">UPDATE 2.1.0</div>
        <ul>
          <li>
            <div class="name">Knowledge Base</div>
          <div class="value">Need help using Vilio? Take a look at our new Knowledge Base: <a target="_blank" :href="urls.knowledgeBase">{{ urls.knowledgeBase }}</a> </div>
          </li>

          <div class="section-title">Management Features</div>
          <li>
            <div class="name">Unit Roles</div>
            <div class="value">Invites can now be created directly on a unit. Existing users can also now be added directly to a unit.</div>
          </li>
          <li>
            <div class="name">Searching</div>
            <div class="value">People, Invites, and Units are now searchable.</div>
          </li>
          <li>
            <div class="name">Bug Fixes</div>
            <div class="value">Minor bug fixes.</div>
          </li>
        </ul>

        <div class="divider"></div>

        <div class="section-title">UPDATE 2.0.1</div>
        <ul>
          <li>
            <div class="name">Mobile Applications</div>
            <div class="value">Vilio 2.0.1 is now available on the Android and iOS app stores.</div>
          </li>
          <li>
            <div class="name">Browser Support</div>
            <div class="value">Added support for Internet Explorer 11.</div>
          </li>
          <li>
            <div class="name">Bug Fixes</div>
            <div class="value">Minor bug fixes.</div>
          </li>
        </ul>

        <div class="text">For a full list of features, changes, and updates, view our <span class="link" @click="openChangelog">full Changelog</span></div>
      </div>

      <div class="version-prompt">
        <v-checkbox class="checkbox" v-model="changelogPrompt" hide-details color="primary" label="Show this when I use a new version for the first time."></v-checkbox>
      </div>

    </div>
    <div class="dialog-footer">
      <v-btn class="button" :loading="lockout.on" flat color="info" @click="closeDialog">Done</v-btn>
    </div>
  </div>
</template>

<script>

  import permissionMixin from '../mixins/permissionMixin.js'

  export default {
    mixins: [permissionMixin],
    data () {
      return {
        title: '', // this is blank because we hack the logo in instead,
        changelogPrompt: false
      }
    },

    props: {
      lockout: {

      }
    },
    
    computed: {
      
      feedback () {
        return this.hasPermissions(['ticketManager', 'ticketAdmin']) ? window.urls.feedback.manager : window.urls.feedback.resident;
      },

      version () {
        return VERSION;
      },

      urls () {
        return window.urls;
      }

    },
    
    created () {
      this.$emit('title', this.title);
      this.changelogPrompt = this.$store.getters.profile.promptChangelog;
    },

    methods: {
    
      closeDialog () {
        if (this.changelogPrompt !== this.$store.getters.profile.promptChangelog) {
          
          this.lockout.on = true;
          
          this.$store.dispatch('saveProfile', {
            user: {
              promptChangelog: this.changelogPrompt
            }
          })
          .then(data => {
            Toast.show('Changelog prompt settings saved.', 'success');
            this.routeRemoveQueries(['dialog', 'dialogAction']);
            this.lockout.on = false;
          })
          .catch(e => {
            Toast.showError(e);
            console.log(e);
            this.lockout.on = false;            
          })
        }   
        else {
          this.routeRemoveQueries(['dialog', 'dialogAction']);          
        }     
      },

      openChangelog () {
        var url = window.urls.changelog;
        if (window.cordova) url += '?fromApp=true';

        window.open(url); 
      },

      openFeedback () {
        window.AppData.openFeedback();
      }
      
    }

  }

</script>

<style lang="scss">

  @import '../css/global.scss';

  #changelog {
    position: relative;

    .header {
      background: $primary;
      height: 56px;
      margin-top: -4px;
    
      .logo {
        position: absolute;
        top: -45px;
        left: 8px;
        width: 150px;
        height: 80px;
        background: url('../assets/logos/vilio-white.svg');      
        @include backgroundCenter();
      }

      .version {
        position: absolute;
        top: 22px;
        left: 79px;

        @include fontPrimary400;
        color: $white;
      }
    }

    .divider {
      background: $borderBlack12;
      height: 1px;
      border: none;
      margin: 40px auto;
      width: 100%;
    }

    .dialog-content {
      padding: 16px;
      font-size: 16px;
      color: $black12;

      .changelog {
        
        padding: 0 24px;
    
        .section-title {
          @include fontPrimary500();
          @include title();
          
          color: $black54;
          text-align: center;
          font-size: 20px;
          margin: 24px 0 16px;
        }

        .name {
          color: $black87;
          margin: 8px 0 0;
          display: list-item;
          list-style-type: disc;
        }
      
        .version {
          color: $black54;
          font-size: 12px;
          margin-bottom: 2px;
        }

        .value {
          display: list-item;
          margin-left: 16px;
          list-style-type: circle;
          color: $black54;
          padding: 4px 0;
        }

        ul {
          margin-left: 8px;
          list-style-type: none;
        }

        .text {
          padding: 40px 0;
          text-align: center;
          color: $black54;
        }
      }

      .version-prompt {
        border-top: $borderBlack12;
        padding: 16px 0 24px;
        text-align: center;
        margin: 0 auto;

        display: flex;
        flex-direction: row;
        justify-content: center;

        .checkbox {
          left: calc(50% - 200px);
        
          label {
            white-space: pre-wrap;
            overflow: auto;
            height: auto;
          }
        }
      }
    }

    .link {
      text-decoration: underline;
      color: $primary;
      cursor: pointer;
    }

    @media screen and (max-width: 700px), screen and (max-height: 780px) {
     
      .header {
        background: $primary;
        height: 55px !important;
      } 

      .dialog-content {
        top: 50px !important;
      }

    }

    @media screen and (max-width: 580px) {
      
      .dialog-content {


        .version-prompt {

          .checkbox {
            left: 16px;
          }
        }
      }
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/Changelog.vue